<div class="page-not-found-wrapper">
  <div class="icon-wrapper empty-state-icon-circle">
    <at-icon>travel_explore</at-icon>
  </div>

  <div class="content">
    <h1 class="content-title">We can't find that page</h1>
    <p class="content-text">The link may be old, or the address may have a typo.</p>

    <div class="content-actions">
      <a atButton class="content-link" variant="primary" [routerLink]="homeUrl()">Go to the home page</a>

      @if (!isLoggedIn()) {
        <a atButton class="content-link" routerLink="/login" variant="outlined">Sign in</a>
      }
    </div>
  </div>
</div>
